<template>
<CCard>
  <CCardHeader>
    <h2>部署詳細</h2>
  </CCardHeader>
  <CCardBody>
    <CRow>
      <CCol sm="8">
        <table class="table" v-if="items">
          <tr>
            <th>部署名</th>
            <td>{{ items.name }}</td>
          </tr>
          <tr>
            <th>部署コード</th>
            <td>{{ items.code }}</td>
          </tr>
          <tr>
            <th>親部署</th>
            <td>{{ items.parent_name }}</td>
          </tr>
          <tr>
            <th>部署長</th>
            <td>{{ items.head_user_name }}</td>
          </tr>
          <tr>
            <th>並び優先度</th>
            <td>{{ items.order_level }}</td>
          </tr>
          <tr>
            <th>備考</th>
            <td>{{ items.remarks }}</td>
          </tr>
        </table>
      </CCol>
    </CRow>

    <CRow class="mt-3 align-items-center">
      <CCol class="text-start">
        <router-link :to="{ name: list }">
          <button class="btn btn-secondary" @click="valueCheck">戻る</button>
        </router-link>
      </CCol>
      <CCol class="text-center">
        <router-link :to="{ name: updateTop, params: { id: id } }">
          <button class="btn btn-info">編集</button>
        </router-link>
      </CCol>
      <CCol></CCol>
    </CRow>
  </CCardBody>
</CCard>
</template>

<script>
import ConstList from './../ConstList'
import axios from 'axios'

export default {
  name: 'DepartmentInfo',
  data() {
    return {
      items: null,
      id: '',
      list: '',
      updateTop: '',
      errors: []
    }
  },
  created() {
    this.list = ConstList.DEPARTMENT_ROUTE_LIST
    this.updateTop = ConstList.DEPARTMENT_UPDATE_TOP
  },
  mounted: function () {
    this.id = this.$route.params.id
    const id = parseInt(this.id)
    axios
      .get(process.env.VUE_APP_API_ORIGIN + '/departments/' + id)
      .then((response) => {
        this.items = response.data
      })
      .catch((error) => {
        axios
          .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: error.message || String(error) }, { headers: { 'Content-Type': 'application/json' } })
          .then(() => {
            alert(ConstList.SYSTEM_ERROR)
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR)
          })
      })
  },
  methods: {
    valueCheck: function () {
      this.$router.push({ name: this.list })
    }
  }
}
</script>

<style scoped>
td {
  word-break: break-all;
}
</style>
